import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

interface AppointmentData {
  serviceType?: string;
  startDate?: string;
  date?: string;
  resourceId?: string;
  pharmacist?: string;
  RoomId?: string;
  room?: string;
  id?: string;
  consultationID?: string;
  endDate?: string;
  duration?: number;
  durationUnit?: string;
  patientID?: string;
  email?: string;
  mobile?: string;
  [key: string]: any;
}

export const AppointmentItems = ({
  items,
  isDarkMode,
  handleAppointmentClick,
  servicePharmacists,
}: any) => {
  const sortedItems = [...items].sort((a, b) => {
    const dateA = new Date(a.displayTimestamp).getTime();
    const dateB = new Date(b.displayTimestamp).getTime();
    return dateA - dateB;
  });

  const pharmacistMap = new Map(
    (servicePharmacists || []).map((p: any) => [p.id, p.name]),
  );

  return (
    <div
      className={`border-t ${isDarkMode ? "border-green-700/50" : "border-green-200"} px-3 pb-3`}
    >
      <div className="mt-3 space-y-2">
        {sortedItems.map((action, index) => {
          let appointmentData: AppointmentData = {};
          try {
            if (action.details?.payload) {
              appointmentData = JSON.parse(action.details.payload);
            } else {
              appointmentData = action.details || {};
            }
          } catch (e) {
            console.warn("Failed to parse appointment payload", e);
            appointmentData = action.details || {};
          }

          const extractTimeFromISO = (isoString: string) => {
            if (!isoString) return "";
            const date = new Date(isoString);
            const hours = date.getUTCHours().toString().padStart(2, "0");
            const minutes = date.getUTCMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
          };

          const serviceType = appointmentData.serviceType || "Appointment";
          const startDate = appointmentData.startDate || appointmentData.date;
          const pharmacistId =
            appointmentData.resourceId || appointmentData.pharmacist || "";
          const pharmacist = pharmacistMap.get(pharmacistId) || pharmacistId;
          const room = appointmentData.RoomId || appointmentData.room || "";

          return (
            <div
              className="flex items-start gap-2 p-2 cursor-pointer"
              onClick={() => handleAppointmentClick(appointmentData)}
            >
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className={`text-xs font-mono text-gray-600`}>
                    #{index + 1}
                  </span>
                  <span
                    className={`text-sm font-medium ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    {serviceType}
                  </span>
                </div>
                <p
                  className={`text-xs ml-6 ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  {startDate && new Date(startDate).toLocaleDateString("en-GB")}
                  {startDate && ` • ${extractTimeFromISO(startDate)}`}
                  {pharmacist && ` • ${pharmacist}`}
                </p>
              </div>
              <div
                className="flex items-center gap-1"
                onClick={(e) => e.stopPropagation()}
              >
                <div onClick={(e) => e.stopPropagation()}>
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      {/* <button
                        className={`p-1 rounded transition-colors ${
                          isDarkMode
                            ? "hover:bg-red-900/20 text-red-400 hover:text-red-300"
                            : "hover:bg-red-50 text-red-600 hover:text-red-700"
                        }`}
                        title="Delete appointment"
                      >
                        <Trash2 className="w-3.5 h-3.5" />
                      </button> */}
                    </AlertDialogTrigger>
                    <AlertDialogContent>
                      <AlertDialogHeader>
                        <AlertDialogTitle>Delete Appointment</AlertDialogTitle>
                        <AlertDialogDescription>
                          Are you sure you want to delete this appointment? This
                          cannot be undone.
                        </AlertDialogDescription>
                      </AlertDialogHeader>
                      <AlertDialogFooter>
                        <AlertDialogCancel>Cancel</AlertDialogCancel>
                        <AlertDialogAction
                          // onClick={() => onDelete(action.id)}
                          className="bg-red-600 hover:bg-red-700"
                        >
                          Delete
                        </AlertDialogAction>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialog>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
